/**
 * Gross Margin % = Gross Profit % before trading-deal rebate.
 * Both percents are of booked net, so:
 *   grossMargin% ≈ marginPercent + tradingDealPercent
 * Prefer the stored pre-rebate field when present.
 */
export function resolveGrossMarginPercent(row: {
  grossMarginPercent?: number | null;
  marginPercent?: number | null;
  tradingDealPercent?: number | null;
}): number | undefined {
  if (row.grossMarginPercent != null && Number.isFinite(row.grossMarginPercent)) {
    return row.grossMarginPercent;
  }
  if (row.marginPercent == null || !Number.isFinite(row.marginPercent)) {
    return undefined;
  }
  const rebatePct =
    row.tradingDealPercent != null && Number.isFinite(row.tradingDealPercent)
      ? row.tradingDealPercent
      : 0;
  return row.marginPercent + rebatePct;
}

export function formatMarginPercent(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return 'N/A';
  return `${new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 }).format(value)}%`;
}
